if (!customElements.get('cart-shipping-details')) {
  /**
   * Represents the details of shipping in a cart, including the ability
   * to handle and validate shipping-related data such as state and country codes.
   * This class extends `HTMLElement` to provide functionality for custom web components.
   */
  class CartShippingDetails extends HTMLElement {
    constructor() {
      super();

      this.amount = 0;
      this.validateTimer = null;
      this.numberWords = {
        1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five',
        6: 'six', 7: 'seven', 8: 'eight', 9: 'nine', 10: 'ten'
      };
      this.states = {
        "Alabama": "AL",
        "Alaska": "AK",
        "American Samoa": "AS",
        "Arizona": "AZ",
        "Arkansas": "AR",
        "California": "CA",
        "Colorado": "CO",
        "Connecticut": "CT",
        "Delaware": "DE",
        "District of Columbia": "DC",
        "Federated States of Micronesia": "FM",
        "Florida": "FL",
        "Georgia": "GA",
        "Guam": "GU",
        "Hawaii": "HI",
        "Idaho": "ID",
        "Illinois": "IL",
        "Indiana": "IN",
        "Iowa": "IA",
        "Kansas": "KS",
        "Kentucky": "KY",
        "Louisiana": "LA",
        "Maine": "ME",
        "Marshall Islands": "MH",
        "Maryland": "MD",
        "Massachusetts": "MA",
        "Michigan": "MI",
        "Minnesota": "MN",
        "Mississippi": "MS",
        "Missouri": "MO",
        "Montana": "MT",
        "Nebraska": "NE",
        "Nevada": "NV",
        "New Hampshire": "NH",
        "New Jersey": "NJ",
        "New Mexico": "NM",
        "New York": "NY",
        "North Carolina": "NC",
        "North Dakota": "ND",
        "Northern Mariana Islands": "MP",
        "Ohio": "OH",
        "Oklahoma": "OK",
        "Oregon": "OR",
        "Palau": "PW",
        "Pennsylvania": "PA",
        "Puerto Rico": "PR",
        "Rhode Island": "RI",
        "South Carolina": "SC",
        "South Dakota": "SD",
        "Tennessee": "TN",
        "Texas": "TX",
        "Utah": "UT",
        "Vermont": "VT",
        "Virgin Islands": "VI",
        "Virginia": "VA",
        "Washington": "WA",
        "West Virginia": "WV",
        "Wisconsin": "WI",
        "Wyoming": "WY"
      };
      this.countries = {
        "Afghanistan": "AF",
        "Åland Islands": "AX",
        "Albania": "AL",
        "Algeria": "DZ",
        "American Samoa": "AS",
        "AndorrA": "AD",
        "Angola": "AO",
        "Anguilla": "AI",
        "Antarctica": "AQ",
        "Antigua and Barbuda": "AG",
        "Argentina": "AR",
        "Armenia": "AM",
        "Aruba": "AW",
        "Australia": "AU",
        "Austria": "AT",
        "Azerbaijan": "AZ",
        "Bahamas": "BS",
        "Bahrain": "BH",
        "Bangladesh": "BD",
        "Barbados": "BB",
        "Belarus": "BY",
        "Belgium": "BE",
        "Belize": "BZ",
        "Benin": "BJ",
        "Bermuda": "BM",
        "Bhutan": "BT",
        "Bolivia": "BO",
        "Bosnia and Herzegovina": "BA",
        "Botswana": "BW",
        "Bouvet Island": "BV",
        "Brazil": "BR",
        "British Indian Ocean Territory": "IO",
        "Brunei Darussalam": "BN",
        "Bulgaria": "BG",
        "Burkina Faso": "BF",
        "Burundi": "BI",
        "Cambodia": "KH",
        "Cameroon": "CM",
        "Canada": "CA",
        "Cape Verde": "CV",
        "Cayman Islands": "KY",
        "Central African Republic": "CF",
        "Chad": "TD",
        "Chile": "CL",
        "China": "CN",
        "Christmas Island": "CX",
        "Cocos (Keeling) Islands": "CC",
        "Colombia": "CO",
        "Comoros": "KM",
        "Congo": "CG",
        "Congo, The Democratic Republic of the": "CD",
        "Cook Islands": "CK",
        "Costa Rica": "CR",
        "Cote D'Ivoire": "CI",
        "Croatia": "HR",
        "Cuba": "CU",
        "Cyprus": "CY",
        "Czech Republic": "CZ",
        "Denmark": "DK",
        "Djibouti": "DJ",
        "Dominica": "DM",
        "Dominican Republic": "DO",
        "Ecuador": "EC",
        "Egypt": "EG",
        "El Salvador": "SV",
        "Equatorial Guinea": "GQ",
        "Eritrea": "ER",
        "Estonia": "EE",
        "Ethiopia": "ET",
        "Falkland Islands (Malvinas)": "FK",
        "Faroe Islands": "FO",
        "Fiji": "FJ",
        "Finland": "FI",
        "France": "FR",
        "French Guiana": "GF",
        "French Polynesia": "PF",
        "French Southern Territories": "TF",
        "Gabon": "GA",
        "Gambia": "GM",
        "Georgia": "GE",
        "Germany": "DE",
        "Ghana": "GH",
        "Gibraltar": "GI",
        "Greece": "GR",
        "Greenland": "GL",
        "Grenada": "GD",
        "Guadeloupe": "GP",
        "Guam": "GU",
        "Guatemala": "GT",
        "Guernsey": "GG",
        "Guinea": "GN",
        "Guinea-Bissau": "GW",
        "Guyana": "GY",
        "Haiti": "HT",
        "Heard Island and Mcdonald Islands": "HM",
        "Holy See (Vatican City State)": "VA",
        "Honduras": "HN",
        "Hong Kong": "HK",
        "Hungary": "HU",
        "Iceland": "IS",
        "India": "IN",
        "Indonesia": "ID",
        "Iran, Islamic Republic Of": "IR",
        "Iraq": "IQ",
        "Ireland": "IE",
        "Isle of Man": "IM",
        "Israel": "IL",
        "Italy": "IT",
        "Jamaica": "JM",
        "Japan": "JP",
        "Jersey": "JE",
        "Jordan": "JO",
        "Kazakhstan": "KZ",
        "Kenya": "KE",
        "Kiribati": "KI",
        "Korea, Democratic People'S Republic of": "KP",
        "Korea, Republic of": "KR",
        "Kuwait": "KW",
        "Kyrgyzstan": "KG",
        "Lao People'S Democratic Republic": "LA",
        "Latvia": "LV",
        "Lebanon": "LB",
        "Lesotho": "LS",
        "Liberia": "LR",
        "Libyan Arab Jamahiriya": "LY",
        "Liechtenstein": "LI",
        "Lithuania": "LT",
        "Luxembourg": "LU",
        "Macao": "MO",
        "Macedonia, The Former Yugoslav Republic of": "MK",
        "Madagascar": "MG",
        "Malawi": "MW",
        "Malaysia": "MY",
        "Maldives": "MV",
        "Mali": "ML",
        "Malta": "MT",
        "Marshall Islands": "MH",
        "Martinique": "MQ",
        "Mauritania": "MR",
        "Mauritius": "MU",
        "Mayotte": "YT",
        "Mexico": "MX",
        "Micronesia, Federated States of": "FM",
        "Moldova, Republic of": "MD",
        "Monaco": "MC",
        "Mongolia": "MN",
        "Montserrat": "MS",
        "Morocco": "MA",
        "Mozambique": "MZ",
        "Myanmar": "MM",
        "Namibia": "NA",
        "Nauru": "NR",
        "Nepal": "NP",
        "Netherlands": "NL",
        "Netherlands Antilles": "AN",
        "New Caledonia": "NC",
        "New Zealand": "NZ",
        "Nicaragua": "NI",
        "Niger": "NE",
        "Nigeria": "NG",
        "Niue": "NU",
        "Norfolk Island": "NF",
        "Northern Mariana Islands": "MP",
        "Norway": "NO",
        "Oman": "OM",
        "Pakistan": "PK",
        "Palau": "PW",
        "Palestinian Territory, Occupied": "PS",
        "Panama": "PA",
        "Papua New Guinea": "PG",
        "Paraguay": "PY",
        "Peru": "PE",
        "Philippines": "PH",
        "Pitcairn": "PN",
        "Poland": "PL",
        "Portugal": "PT",
        "Puerto Rico": "PR",
        "Qatar": "QA",
        "Reunion": "RE",
        "Romania": "RO",
        "Russian Federation": "RU",
        "RWANDA": "RW",
        "Saint Helena": "SH",
        "Saint Kitts and Nevis": "KN",
        "Saint Lucia": "LC",
        "Saint Pierre and Miquelon": "PM",
        "Saint Vincent and the Grenadines": "VC",
        "Samoa": "WS",
        "San Marino": "SM",
        "Sao Tome and Principe": "ST",
        "Saudi Arabia": "SA",
        "Senegal": "SN",
        "Serbia and Montenegro": "CS",
        "Seychelles": "SC",
        "Sierra Leone": "SL",
        "Singapore": "SG",
        "Slovakia": "SK",
        "Slovenia": "SI",
        "Solomon Islands": "SB",
        "Somalia": "SO",
        "South Africa": "ZA",
        "South Georgia and the South Sandwich Islands": "GS",
        "Spain": "ES",
        "Sri Lanka": "LK",
        "Sudan": "SD",
        "Suriname": "SR",
        "Svalbard and Jan Mayen": "SJ",
        "Swaziland": "SZ",
        "Sweden": "SE",
        "Switzerland": "CH",
        "Syrian Arab Republic": "SY",
        "Taiwan, Province of China": "TW",
        "Tajikistan": "TJ",
        "Tanzania, United Republic of": "TZ",
        "Thailand": "TH",
        "Timor-Leste": "TL",
        "Togo": "TG",
        "Tokelau": "TK",
        "Tonga": "TO",
        "Trinidad and Tobago": "TT",
        "Tunisia": "TN",
        "Turkey": "TR",
        "Turkmenistan": "TM",
        "Turks and Caicos Islands": "TC",
        "Tuvalu": "TV",
        "Uganda": "UG",
        "Ukraine": "UA",
        "United Arab Emirates": "AE",
        "United Kingdom": "GB",
        "United States": "US",
        "United States Minor Outlying Islands": "UM",
        "Uruguay": "UY",
        "Uzbekistan": "UZ",
        "Vanuatu": "VU",
        "Venezuela": "VE",
        "Viet Nam": "VN",
        "Virgin Islands, British": "VG",
        "Virgin Islands, U.S.": "VI",
        "Wallis and Futuna": "WF",
        "Western Sahara": "EH",
        "Yemen": "YE",
        "Zambia": "ZM",
        "Zimbabwe": "ZW"
      }
      this.provinces = [];
      this.address = {};
      this.vouchersEls = [];

      if (document.querySelector('cart-vouchers')) {
        this.vouchersEls = document.querySelectorAll('cart-vouchers');
      }

      let cartSection = this.closest('.cart-section');
      if (cartSection) {
        cartSection.appendChild(this.querySelector('.cart-shipping-details--error-popup'));
      }

      let savedAddress = localStorage.getItem('shippingAddress');
      if (savedAddress) this.address = JSON.parse(savedAddress);

      this.setupEventListeners();
    }

    /**
     * Sets up various event listeners for the component to handle user interactions and updates.
     *
     * The method attaches the following event listeners:
     * - 'cart:refresh' event on the document to trigger the `refresh` method.
     * - 'cart:vouchers-ready' event on the document to invoke the `preFillForm` method.
     * - Click event on a `.cart-calculate-shipping` button to validate the form and handle submission when valid.
     * - Input event on all input fields to remove error states when valid input is detected.
     * - Change event on input and select fields to remove error states and trigger address change handling.
     * - Change event on country select elements to update provinces and country-specific address details.
     *
     * @return {void} This method does not return a value.
     */
    setupEventListeners() {

      document.addEventListener('cart:vouchers-ready', () => {
        this.preFillForm();
      });

      this.querySelector('.cart-calculate-shipping').addEventListener('click', (e) => {
        e.preventDefault();
        let valid = this.validateForm();
        if (valid) {
          this.handleSubmit();
        }
      });

      this.querySelectorAll('input').forEach(input => {
        input.addEventListener('input', (e) => {
          if (input.value && input.value.length > 0) {
            input.closest('.col').classList.remove('error');
          }
        });
      });

      this.querySelectorAll('input, select').forEach(input => {
        input.addEventListener('change', (e) => {
          if (input.value && input.value.length > 0) {
            input.closest('.col').classList.remove('error');
          }
          this.handleAddressChange();
        });
      });

      this.querySelectorAll('select[name="shipping_address[country]"]').forEach(select => {
        select.addEventListener('change', (e) => {
          if (select.querySelector(`option[value="${select.value}"]`)) {
            this.provinces = JSON.parse(select.querySelector(`option[value="${select.value}"]`).dataset.provinces);
            this.updateProvinces();

            this.address['shipping_address[country_code]'] = this.countries[select.value];
            this.updateAddress();
          }
        });
      });

    }

    /**
     * Validates the form by checking the required input and select elements for valid values.
     * If any required field is empty or invalid, the corresponding UI elements are updated to show errors.
     * Also updates the `address` object with valid field values and handles province/state mapping.
     *
     * @return {boolean} Returns `true` if the form is valid, otherwise `false`.
     */
    validateForm() {
      let _this = this;
      let form = this.querySelector('.cart-shipping-details--form');
      let errorPopup = document.querySelector('.cart-shipping-details--error-popup');

      let valid = true;

      form.querySelectorAll('input[required]').forEach(input => {
        let col = input.closest('.col');
        col.classList.remove('error');
        errorPopup.classList.add('hidden-opacity');

        if (!input.value || input.value.length < 1) {
          valid = false;
          col.classList.add('error');
          errorPopup.classList.remove('hidden-opacity');

          setTimeout(() => {
            errorPopup.classList.add('hidden-opacity');
          }, 3000);
        }

        this.address[input.name] = input.value;
      });

      form.querySelectorAll('select[required]').forEach(select => {
        let col = select.closest('.col');
        col.classList.remove('error');
        errorPopup.classList.add('hidden-opacity');

        if (!select.value || select.value === '---') {
          valid = false;
          col.classList.add('error');
          errorPopup.classList.remove('hidden-opacity');

          setTimeout(() => {
            errorPopup.classList.add('hidden-opacity');
          }, 3000);
        }
        this.address[select.name] = select.value;

        if (select.name === 'shipping_address[province]') {
          this.address['shipping_address[state_code]'] = select.value;
        }
      });

      this.updateAddress();

      return valid;
    }

    /**
     * Updates the stored shipping address in the session storage.
     * The method converts the current address object into a JSON string
     * and saves it under the key 'shippingAddress' in session storage.
     *
     * @return {void} No return value.
     */
    updateAddress() {
      localStorage.setItem('shippingAddress', JSON.stringify(this.address));
    }

    /**
     * Handles the submission of a form, collecting input and select field values, encoding them as a query string,
     * and executing asynchronous operations to prepare and retrieve shipping rates. Updates the shipping rates
     * or displays an error popup if operations fail.
     *
     * @return {void} This method does not return a value.
     */
    handleSubmit() {
      let fields = this.querySelectorAll('input, select');
      let data = {};
      fields.forEach(field => {
        data[field.name] = field.value;
      });

      let string = '';

      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          string += `${key}=${data[key]}&`;
        }
      }

      string = encodeURI(string);

      this.prepareShippingRates(string).then(
        (prepareResponse) => {
          this.asyncShippingRates(string).then(
            (asyncResponse) => {
              this.updateShippingRates(asyncResponse?.response?.shipping_rates ?? []);
            }
          ).catch(error => {
            this.resetShippingMethod();
            this.showErrorPopup(error.message ?? '');
          });
        }
      ).catch(error => {
        this.resetShippingMethod();
        this.showErrorPopup(error.message ?? '');
      });
    }

    /**
     * Prepares shipping rates by making a POST request to the specified endpoint with the given query string.
     *
     * @param {string} string - The query string containing the parameters for preparing shipping rates.
     * @return {Promise<object>} A promise that resolves with an object containing the status and message upon success,
     * or rejects with an object containing the response and error message upon failure.
     */
    prepareShippingRates(string) {
      return new Promise(async (resolve, reject) => {

        fetch(`/cart/prepare_shipping_rates.json?${string}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
        })
          .then(response => response.json())
          .then(response => {
            if (response == null) {
              resolve({
                status: 200,
                message: 'Success',
              });
              return;
            }

            let message = '';

            for (const [key, value] of Object.entries(response)) {
              if (message.length > 0) message += '<br/>';
              message += value[0];
            }

            reject({
              response: response,
              message: message,
            });
          });
      });


    }

    /**
     * Fetches asynchronous shipping rates based on the provided query string.
     *
     * @param {string} string - The query string parameters to include in the API call.
     * @return {Promise<Object>} A promise that resolves to an object containing the status, message, and response data from the API call, or rejects with an error object.
     */
    asyncShippingRates(string) {
      return new Promise(async (resolve, reject) => {

        fetch(`/cart/async_shipping_rates.json?${string}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        })
          .then(response => response.json())
          .then(response => {
            if (response.hasOwnProperty('shipping_rates')) {
              resolve({
                status: 200,
                message: 'Success',
                response: response
              });
              return;
            }

            let message = '';

            for (const [key, value] of Object.entries(response)) {
              if (message.length > 0) message += '<br/>';
              message += value[0];
            }

            reject({
              response: response,
              message: message,
            });
          });

      });
    }

    /**
     * Updates the shipping rates displayed in the UI based on the provided rates array. Dynamically modifies elements
     * to match the number of available rates and updates the selected shipping method.
     *
     * @param {Array} rates - An array of shipping rate objects. Each object should include `name`, `price`, and `presentment_name` properties.
     * @return {void} This method does not return a value.
     */
    updateShippingRates(rates) {
      rates.unshift({
        name: 'Pick Up',
        presentment_name: 'Pick Up',
        price: 0,
        type: 'pick_up'
      })

      let count = rates.length;

      if (count < 1) return;

      if (count === 1) {
        this.querySelector('.shipping-rates .single').classList.remove('hidden');
      } else {
        let target = this.querySelector('.shipping-rates .multiple');
        let text = target.innerText;
        text = text.replace('[[COUNT]]', this.numberWords[count]);
        target.innerText = text;
        target.classList.remove('hidden');
      }

      let list = this.querySelector('.shipping-rates-list');
      list.innerHTML = '';

      let i = 0;
      rates.forEach(rate => {
        let li = document.createElement('li');

        let checkmark = document.createElement('span');
        checkmark.classList.add('checkmark');

        let label = document.createElement('label');
        label.for = rate.name;
        label.classList.add('custom-radio');

        let input = document.createElement('input');
        input.type = 'radio';
        input.name = 'shipping_rate_id';
        input.id = rate.name;
        input.value = i;
        input.dataset.price = rate.price;
        input.dataset.name = rate.name;
        input.dataset.type = rate.type ?? 'shipping';

        let checked = false;

        if (this.address['shipping_method']) {
          if (this.address['shipping_method']['title'] === rate.name) {
            checked = true;
          }
        }

        if (checked) {
          input.checked = true;
          this.address['shipping_method'] = {
            "title": rate.name,
            "price": parseFloat(rate.price) * 100,
            "type": rate.type ?? 'shipping',
          }
          this.updateAddress();
        }

        label.innerText = `${rate.presentment_name} • ${rate.price == 0 ? 'FREE' : `$${parseFloat(rate.price).toFixed(2)}`}`;
        label.prepend(input);
        label.appendChild(checkmark);
        li.appendChild(label);
        list.appendChild(li);

        i++;
      });

      this.querySelectorAll('[name="shipping_rate_id"]').forEach(radio => {
        radio.addEventListener('change', (e) => this.handleShippingRateChange(e));
      });

      if (!this.vouchersEls) {
        if (document.querySelector('cart-vouchers')) {
          this.vouchersEls = document.querySelector('cart-vouchers');
        }
      }
      if (this.vouchersEls) {

        this.vouchersEls.forEach((el) => {
          el.handleCalculateVouchers();
        });
      }
    }

    /**
     * Updates the provinces in a dropdown select element for a shipping address.
     * The method clears the existing options and populates the dropdown with
     * provinces derived from the `provinces` array. Each province is represented
     * as an option tag, and its value is determined based on the `states` mapping
     * or the province's own identifier if no mapping exists.
     *
     * @return {void} This method does not return a value.
     */
    updateProvinces() {
      let select = this.querySelector('select[name="shipping_address[province]"]');
      select.innerHTML = '';
      this.provinces.forEach(province => {
        let option = document.createElement('option');
        if (this.states[province[0]]) {
          option.value = this.states[province[0]];
        } else {
          option.value = province[0];
        }
        option.innerText = province[1];
        select.appendChild(option);
      });
    }

    /**
     * Fills in the form fields with the data from the `address` object, if available.
     * Updates province options based on the selected country and validates the form upon completion.
     * Calls the submit handler if the form is valid after pre-filling.
     *
     * @return {void} This method does not return a value.
     */
    preFillForm() {
      if (Object.keys(this.address).length > 0) {

        for (const [key, value] of Object.entries(this.address)) {
          let input = this.querySelector(`[name="${key}"]`);
          if (input) {
            input.value = value;

            if (key.indexOf('[country]') !== -1) {
              this.provinces = JSON.parse(input.querySelector(`option[value="${value}"]`).dataset.provinces);
              this.updateProvinces();
            }
          }
        }

        let valid = this.validateForm();
        if (valid) {
          this.handleSubmit();
        }
      }
    }

    /**
     * Handles changes to the address input by clearing timeouts, updating the UI
     * to reflect the current state of shipping rates, and validating the form
     * after a delay.
     *
     * This method hides visible shipping rate elements, clears the shipping rates
     * list, and, if applicable, hides voucher elements. Then, it sets a timeout
     * to validate the form after a delay of 3500 milliseconds.
     *
     * @return {void} This method does not return a value.
     */
    handleAddressChange() {
      clearTimeout(this.validateTimer);

      this.resetShippingMethod();

      this.querySelectorAll('.shipping-rates .single, .shipping-rates .multiple').forEach(el => {
        el.classList.add('hidden')
      });
      this.querySelector('.shipping-rates-list').innerHTML = '';

      if (this.vouchersEls) {
        this.vouchersEls.forEach((el) => {
          el.hide();
        });
      }

      this.validateTimer = setTimeout(() => {
        this.validateForm();
      }, 3500);
    }

    resetShippingMethod() {
      if (this.address && this.address.shipping_method) {
        delete this.address.shipping_method;
        this.updateAddress();
      }
      document.dispatchEvent(new CustomEvent('cart:shipping-method-reset'));
    }

    /**
     * Displays an error popup with the specified message and hides it automatically after a delay.
     *
     * @param {string} message - The error message to display in the popup.
     * @return {void} This method does not return a value.
     */
    showErrorPopup(message) {
      let errorPopup = document.querySelector('.cart-shipping-details--error-popup');
      let text = errorPopup.querySelector('.popup-modal .text');
      text.innerText = message;
      errorPopup.classList.remove('hidden-opacity');

      setTimeout(() => {
        errorPopup.classList.add('hidden-opacity');
      }, 3000);
    }

    /**
     * Handles the change event for shipping rates and updates the shipping method in the associated address.
     *
     * @param {Event} e - The event object triggered by the shipping rate selection.
     * @return {void} This method does not return a value.
     */
    handleShippingRateChange(e) {
      let selected = this.querySelector(`input[name="shipping_rate_id"]:checked`);
      this.address.shipping_method = {
        "title": selected.dataset.name,
        "type": selected.dataset.type,
        "price": parseInt(parseFloat(selected.dataset.price) * 100),
      };
      this.updateAddress();
      document.dispatchEvent(new CustomEvent('cart:shipping-method-changed'));
    }
  }

  customElements.define('cart-shipping-details', CartShippingDetails);
}